import app from 'flarum/forum/app';
import on from './gate';
import pollLearn, { building } from './pollLearn';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import Link from 'flarum/common/components/Link';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
export default class LearnPage extends Page {
  page = null;
  error = '';
  slug = '';
  sequence = 0;
  stopPolling = () => {};
  onremove(v) {
    this.sequence++;
    this.stopPolling();
    super.onremove(v);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  onbeforeupdate() {
    if (this.slug !== m.route.param('slug')) this.load();
  }
  load() {
    if (!on()) return;
    this.stopPolling();
    const sequence = ++this.sequence;
    const slug = this.slug = m.route.param('slug');
    this.page = null;
    this.error = '';
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/challenges/learn/' + encodeURIComponent(slug)
    }).then(r => {
      if (this.slug === slug && sequence === this.sequence) {
        this.page = r.data;
        app.setTitle(r.data.title);
        if (building(r.data.status)) this.stopPolling = pollLearn(slug, page => {
          if (this.slug === slug && sequence === this.sequence) this.page = page;
        });
      }
    }).catch(() => {
      if (sequence === this.sequence) this.error = 'Could not load the Learn page.';
    }).finally(() => m.redraw());
  }
  async click(e) {
    const approve = e.target.closest('[data-approve-song]');
    if (approve) {
      approve.disabled = true;
      try {
        await app.request({
          method: 'POST',
          url: app.forum.attribute('apiUrl') + '/challenges/songs/' + approve.dataset.approveSong + '/approve',
          body: {
            approved: true
          }
        });
        this.load();
      } finally {
        approve.disabled = false;
        m.redraw();
      }
    }
    const preview = e.target.closest('button.preview');
    // Video id/start sit on the button (old pages) or on its .lp-card (looper pages since 11 Oct).
    const data = preview?.closest('[data-video]')?.dataset;
    if (data && /^[\w-]{11}$/.test(data.video) && /^\d+$/.test(data.start)) {
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + data.video + '?start=' + data.start + '&autoplay=1';
      frame.title = preview.getAttribute('aria-label') || 'Video lesson';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      // The forum sends Referrer-Policy: same-origin; YouTube refuses embeds without a referrer (error 153).
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      preview.replaceWith(frame);
    }
  }
  view() {
    if (!on()) return null;
    return m(PageStructure, {
      className: "Challenges-learn",
      sidebar: () => m(IndexSidebar, null)
    }, m(Link, {
      className: "Learn-back",
      href: app.route('challenges.index')
    }, "\u2190 Browse Learn pages"), m("article", {
      className: "LearnPage",
      onclick: this.click.bind(this)
    }, this.page ? m.trust(this.page.html) : m("p", null, this.error || 'Loading Learn page…')));
  }
}